import { ZERO } from '@snap-types/types/decimal';

import {
  CalculateProductOptionPriceParams,
  CalculateProductOptionPriceResult,
} from './types';

export function calculateBatchQuantityPriceAddition({
  option,
  quantity,
}: CalculateProductOptionPriceParams): CalculateProductOptionPriceResult {
  if (!option.price) {
    return {
      isSuccess: false,
      error: 'Missing price',
      calculationMode: option.calculationMode,
    };
  }

  if (!option.unitsPerBatch) {
    return {
      isSuccess: false,
      error: 'Missing unitsPerBatch',
      calculationMode: option.calculationMode,
    };
  }

  if (option.unitsPerBatch.lte(ZERO)) {
    return {
      isSuccess: false,
      error: 'Units per batch must be greater than 0',
      calculationMode: option.calculationMode,
    };
  }

  if (quantity.lte(ZERO)) {
    return {
      isSuccess: false,
      error: 'Quantity must be greater than 0',
      calculationMode: option.calculationMode,
    };
  }

  const batches = quantity.dividedBy(option.unitsPerBatch).ceil();
  const totalBatchesPrice = batches.times(option.price);
  const unitPriceAddition = totalBatchesPrice.dividedBy(quantity);

  return {
    isSuccess: true,
    unitPriceAddition,
    calculationMode: option.calculationMode,
  };
}
